export default {
  additionalCountriesModalTitle: {
    id: 'bo_seller_profile_page_tax_residence_additional_countries_modal_title',
    defaultMessage: 'Add other establishments',
  },
  updatingAdditionalCountries: {
    id: 'bo_seller_profile_page_tax_residence_additional_countries_updating',
    defaultMessage: 'Updating your other establishments...',
  },
  submitButton: {
    id: 'bo_seller_profile_page_tax_residence_additional_countries_confirm_button',
    defaultMessage: `{additionalCountryCount, plural,
          =0 {Confirm}
          one {Confirm}
          other {Confirm # selected}
        }`,
  },
  additionalCountriesUpdateSuccessTitle: {
    id: 'bo_seller_profile_page_tax_residence_additional_countries_update_success_title',
    defaultMessage: `{additionalCountryCount, plural,
            =0 {No other establishment added ✔️}
            one {# other establishment added ✔️}
            other {# other establishments added ✔️}
          }`,
  },
  additionalCountrieUpdateSuccessContent: {
    id: 'bo_seller_profile_page_tax_residence_additional_countries_update_success_error',
    defaultMessage: 'Nice work.',
  },
  cancelButton: {
    id: 'bo_seller_profile_page_tax_residence_main_country_cancel_button',
    defaultMessage: 'Cancel',
  },
}
